import { render, staticRenderFns } from "./HKLRouterLink.vue?vue&type=template&id=5e29a632&scoped=true&"
var script = {}
import style0 from "./HKLRouterLink.vue?vue&type=style&index=0&id=5e29a632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e29a632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e29a632')) {
      api.createRecord('5e29a632', component.options)
    } else {
      api.reload('5e29a632', component.options)
    }
    module.hot.accept("./HKLRouterLink.vue?vue&type=template&id=5e29a632&scoped=true&", function () {
      api.rerender('5e29a632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Link/HKLRouterLink.vue"
export default component.exports